<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="420px"
    >
        <v-card>
            <v-container class="pa-4">
                <v-card-title class="text-md-h6 text-center text-break mb-3 font-weight-bold">
                    {{ $t('indicators.messages.download_indicator_question') }}
                </v-card-title>
                <v-card-actions class="justify-center pt-4">
                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}
                    </v-btn>

                    <v-btn
                        class="v-btn--primary"
                        :disabled="downloadingBible"
                        text
                        @click="confirmDownload"
                    >{{ $t('app.confirm') }}
                    </v-btn>

                    <v-progress-circular
                        indeterminate
                        class="mt-2 ml-2"
                        v-if="downloadingBible"
                        color="grey"
                        size="16"
                    ></v-progress-circular>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import {EventBus} from "@/event-bus";

export default {
    name: "DownloadBibleDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true,
        },
    },

    data() {
        return {
            downloadingBible: false,
        };
    },

    methods: {
        /**
         * Emits dialog confirmed event
         */
        confirmDownload() {
            this.downloadingBible = true;
            this.$emit('confirmBibleDownload');
        },

        /**
         * Closes the download dialog and resets the spinner
         */
        closeDialog() {
            this.downloadingBible = false; // Reset spinner state
            this.$emit('cancelBibleDownload');
        },

        /**
         * Hides spinner after download bible succeed
         */
        stopBibleDownloadingSpinner() {
            this.downloadingBible = false;
        }
    },

    watch: {
        showDialog(newVal) {
            if (!newVal) {
                this.downloadingBible = false; // Ensure spinner is reset when dialog is closed
            }
        }
    },

    /**
    created() {
        EventBus.$on('reports.management.stop-download-spinner', this.stopBibleDownloadingSpinner);
    },

    beforeDestroy() {
        EventBus.$off('reports.management.stop-download-spinner', this.stopBibleDownloadingSpinner);
    }
    **/
}
</script>

<style scoped>

</style>
